import {
  LOGIN_USER,
  LOGIN_ERROR,
  LOGIN_DISABLED,
  LOGOUT_USER,
  UPDATE_USER,
  UPDATE_PROFILE_PICTURE,
  UPDATE_VIEW_MODE,
} from "constants/actionTypes";

var user = JSON.parse(localStorage.getItem("user"));
var mode = localStorage.getItem("view_mode");

const INITIAL_STATE = user
  ? {
      logged: true,
      viewMode: mode,
      infos: user,
      loginError: false,
      disabledError: false,
    }
  : {
      logged: false,
      viewMode: mode,
      infos: {},
      loginError: false,
      disabledError: false,
    };

function formReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case LOGIN_USER:
      return {
        logged: true,
        viewMode: state.viewMode,
        infos: action.payload,
        loginError: false,
        disabledError: false,
      };

    case LOGIN_ERROR:
      return {
        logged: false,
        viewMode: state.viewMode,
        infos: {},
        loginError: true,
        disabledError: false,
      };

    case LOGIN_DISABLED:
      return {
        logged: false,
        viewMode: state.viewMode,
        infos: {},
        loginError: true,
        disabledError: true,
      };

    case LOGOUT_USER:
      return {
        logged: false,
        viewMode: state.viewMode,
        infos: {},
        loginError: false,
        disabledError: false,
      };

    case UPDATE_USER:
      return {
        logged: true,
        viewMode: state.viewMode,
        infos: action.payload,
        loginError: false,
        disabledError: false,
      };

    case UPDATE_PROFILE_PICTURE:
      return {
        logged: true,
        viewMode: state.viewMode,
        infos: {
          ...state.infos,
          document: action.payload,
        },
        loginError: false,
        disabledError: false,
      };

    case UPDATE_VIEW_MODE:
      return {
        logged: state.logged,
        viewMode: action.payload,
        infos: state.infos,
        loginError: state.loginError,
        disabledError: state.disabledError,
      };

    default:
      return state;
  }
}

export default formReducer;
